 <template>
  <div class="box4">
    <pageTitle title="院校介绍"/>
    <div class="text text1">史蒂文斯理工学院(简称SIT)始创于1870年，是美国历史最为悠久的研究型私立理工大学，美国国家一级大学。学校坐落于新泽西州的霍博肯市，与纽约曼哈顿岛隔河相望，是世界上地理位置最佳的学校之一。</div>
    <div class="text text2">史蒂文斯理工学院是美国理工强校，与麻省理工、加州理工、伦斯勒理工学院并称为美国四大理工大学，与麻省理工、加州理工、卡内基梅隆大学等22所高校同为独立科技大学联盟创始成员。在微电子及光电技术、无线通信、数据科学、机械工程、环境科学以及工程、材料科学和工程、现代管理等领域的教学和科研都处于美国领先地位。</div>
    <div class="main-box">
      
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {
      
    };
  },
  
};
</script>

<style lang="less" scoped>
.box4 {
  padding: 80px 0;
  width:100%;
  background: #F3F3F9;
  /deep/.course-title-box .course-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 44px;
    color: #272020;
    line-height: 64px;
    text-align: center;
  }
  .text {
    padding: 0 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #231D1D;
    line-height: 44px;
    text-align: justify;
  }
  .text1 {
    margin-top: 48px;
  }
  .text2 {
    margin-top: 8px;
  }
  .main-box {
    margin: 48px 0 0 40px;
    width: 670px;
    height: 424px;
    background: url("../../../assets/coursePage/stevens/box4/main.png") no-repeat;
    background-size: cover;
  }
}
</style>
